module.exports = __webpack_public_path__ + "static/media/ferry-icon.f3086fd4.png";